<template>
  <div class="techPage">
    <!-- banner -->
    <div class="banner">
      <img
        src="https://upload.vwingist.com/melscn/0image/2025/04/5711239710790026098.jpeg"
        alt=""
      />
    </div>

    <div class="group-layout group-layout-1 flex-rowl">
      <div class="media-section">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/03/5599323952409609436.png"
          alt=""
        />
      </div>
      <div class="text-section">
        <h1 class="main-title">科技與專業</h1>
        <br />
        <p class="sub-title-2">瑞士科研保障，開啟護膚新境界</p>
        <p class="content">
          深度融合世界領先的科研實力與匠心工藝，憑藉瑞士聯邦衛生局的權威認證與歐盟
          GMP 標準的嚴格把控，為每一款產品築牢科學與安全的基石。
        </p>
        <br /><br />
        <p class="sub-title-2">科學與安全的雙重承諾</p>
        <p class="content">
          Cellcare 實驗室嚴格遵循瑞士聯邦衛生局的認證標準，<br />
          確保從研發到生產的每一個環節都符合最高規格的質量要求。
        </p>
        <br /><br />
        <p class="sub-title-2">「基因抗醣化素（肌肽）」</p>
        <p class="content">GENE ANTI-IMMOLATION</p>
        <br /><br />
        <p class="content">
          防止肌膚膠原蛋白酶化，使真皮層增生膠原蛋白，鞏固真皮組織<br />使膚觸飽滿有活力。<br />
          外在抗氧化，內在抗醣化，告別衰老鬆弛的皮膚。
        </p>
      </div>
    </div>
    <div class="group-layout group-layout-2 flex-rowl">
      <div class="text-section">
        <h1 class="main-title">“全球頂尖技術合作”</h1>
        <h1 class="sub-title-2">創新與卓越的泉源</h1>
        <div class="main-content">
          <h1 class="main-title">「美寶麗Mibelle集團」</h1>
          <p class="content">
            作為全球知名的植物活性成分供應商，美寶麗集團以其持續的研發投入和科技創新聞名於世，為VESCOR的護膚產品賦予了獨特的抗衰老和修復功能。
          </p>
          <br /><br />
          <h1 class="main-title">「CRB工廠」</h1>
          <p class="content">
            作為全球領先的純生態原料研究生產工廠之一，CRB專注於利用全球最佳的植物和自然成分，開發高效且安全的護膚原料，確保了高度的純淨性和卓越的修復效果。
          </p>
        </div>
      </div>
      <div class="media-section image-container">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/03/4671140486630614563.png"
          alt=""
        />
      </div>
    </div>

    <div class="group-layout group-layout-3 flex-rowl">
      <div class="media-section image-container">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/04/5542491209662508161.jpeg"
          alt=""
          class="zoomable-image"
        />
      </div>
      <div class="text-section">
        <h1 class="main-title">“天然精粹”</h1>
        <h1 class="sub-title-1">阿爾卑斯山溫泉水與有機植物原料</h1>
        <p class="content">
          采用瑞士瓦萊州冰川自湧泉，經過多重淨化和礦物質調配，能夠有效滋養肌膚，保濕滲透效率較常規溫泉水提升
          240%。<br />
          結合歐洲有機土地種植的優質植物原料，幫助肌膚恢復活力，煥發青春光彩。
        </p>
      </div>
    </div>
    <div class="group-layout group-layout-4 flex-rowl">
      <div class="text-section">
        <h1 class="main-title">“科研與匠心工藝的完美結合”</h1>
        <h1 class="sub-title-1">創新與傳承的融合。</h1>
        <p class="content">
          VESCOR的護膚系列不僅注重科學研發，更將匠心工藝融入其中。
          我們致力於將現代科技與自然成分完美融合，創造出革命性的護膚科技。<br /><br />
          從原料篩選到配方研發，從生產流程到質地優化，每一個環節都體現了對科學的尊重與對美學的追求。
        </p>
      </div>
      <div class="media-section image-container">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/04/5039384516687410805.jpeg"
          alt=""
          class="zoomable-image"
        />
      </div>
    </div>

    <div class="other_wrap">
      <div class="content flex-colc wow animate__animated animate__slideInUp">
        <div class="title">“瑞士細胞級抗衰科技 | 賦能內外兼修的當代菁英肌”</div>
        <p class="txt1">創新與卓越的泉源</p>
        <div class="txt">
          <p>
            當都市霓虹侵蝕肌膚防禦屏障，當跨時區差旅打破細胞修護節<br />律，當多重
            角色壓力加速膠原流失。
          </p>
          <p>
            VESCOR以瑞士Cellcare實驗室37年研究成果，構建「三維生物護城河」，<br />
            為現代女性的肌膚築起智慧防線。
          </p>
        </div>
        <p class="txt2">「全球權威品質認證體系」</p>
        <div class="txt">
          <p>瑞士聯邦藥品監督管理局（SWISSMEDIC）A級認證生產體系。</p>
          <p>欧盟EMA药用级GMP标准原料筛选系统。</p>
        </div>
      </div>
    </div>

    <div class="group-layout group-layout-5">
      <div class="group-layout-container flex-rowl">
        <div class="media-section image-container">
          <img
            src="https://upload.vwingist.com/melscn/0image/2025/03/5514280874527803054.png"
            alt=""
            class="zoomable-image"
          />
        </div>
        <div class="text-section">
          <h1 class="main-title">“尖端生物傳導系統”</h1>
          <h1 class="sub-title-1">多層靶向遞送科技</h1>
          <p class="content mb_50">
            搭載美寶麗集團專利脂質體包裹工藝，通過雙親性載體精准輸送<br />阿爾卑斯雪絨花活性成分，經瑞士SGS實驗室檢測顯示，<br />28天表皮層鎖水密度呈現顯著性改善。
          </p>
          <h1 class="sub-title-1">生態屏障修護體系</h1>
          <p class="content">
            採用CRB工廠超臨界CO2梯度萃取科技，完整保留金盞花黃酮與<br />積雪草苷活性分子群，通過人體功效測試驗證具有加速表皮修護行程的作用。
          </p>
        </div>
      </div>
      <div class="group-layout-list flex-rowc">
        <div class="group-layout-item">
          <p class="main-title">“阿爾卑斯生態矩陣”</p>
          <p class="main-subtitle">2000公尺冰川活性水。</p>
          <p class="main-txt">
            採用瑞士瓦萊州冰川自湧泉，經磁共振納米化處理，<br />
            形成直徑 1.8nm的「六角水分子簇」，<br /><br />
            實驗室資料顯示保濕滲透效率較 常規溫泉水提升240%。
          </p>
        </div>
        <div class="group-layout-item">
          <p class="main-title">“有機植物能量庫”</p>
          <p class="main-subtitle">與歐盟Ecocert認證農場合作培育</p>
          <p class="main-txt">
            √晝夜溫差18℃環境生長的山地玫瑰。<br /><br />
            √紫外線指數8+區域馴化的高山火絨草。<br /><br />
            √經3代育種優化的藥用級積雪草。
          </p>
        </div>
      </div>
      <div class="text-section">
        <h1 class="main-title">
          「VESCOR 不止創造護膚品，更構建肌膚的「生物節律算法」
        </h1>
        <p class="content">
          每一次護理，都是細胞與科技的優雅共振。我們以雪絨花般純粹的守護，讓肌膚與靈魂同步新生。
        </p>
        <br /><br />
        <h1 class="main-title">「真正的奢侈，是讓時光成為加持而非對手」</h1>
        <p class="content">
          ——VESCOR 瑞式美學，獻給每一個在時光長河中優雅綻放真我風采的妳。
        </p>
      </div>
    </div>

    <div class="join_wrap">
      <div class="content flex-colc wow animate__animated animate__slideInUp">
        <div class="title">
          <p class="txt1 f-times-new-roman">Join</p>
          <p class="txt2">VESCOR致力於為內外兼修的現代女性打造</p>
          <p class="txt3">奢寵保養體驗計劃</p>
        </div>
        <div class="txt">
          <p>
            我們一起，追求自然與科學的平衡，關注肌膚內外健康，同時無懼時間流轉，堅定探索自我。
          </p>
          <p>
            無論是在職場中自信應對挑戰，或是在生活中優雅淡然，VESCOR始終與她們相伴，賦予她們從容與美麗。
          </p>
        </div>
        <div class="more flex-rowc" @click="handleGo('ProductPage')">了解詳情...</div>
      </div>
    </div>
  </div>
</template>
    <script>
export default {
  name: "TechPage",
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleGo(link) {
      this.$router.push(link);
    },
  },
};
</script>
  <style lang="less">
.techPage {
  .image-container {
    display: inline-block; /* 确保容器只占用图片的空间 */
    overflow: hidden; /* 隐藏超出容器的部分 */
  }
  .zoomable-image {
    transition: transform 0.3s ease; /* 添加过渡效果，使放大过程更平滑 */
    cursor: pointer;
    &:hover {
      transform: scale(1.07); /* 鼠标悬停时放大图片 */
    }
  }
  .banner {
    // height: 600px;
    margin-bottom: 110px;
  }
  .group-layout {
    align-items: flex-start;
    .main-title {
      font-family: "SourceHanSerifCN-Medium", sans-serif;
    }
    .sub-title-1 {
      font-family: "SourceHanSerifCN-Medium", sans-serif;
    }
    .sub-title-2 {
      font-family: "SourceHanSerifCN-Medium", sans-serif;
    }
    .main-subtitle {
      font-family: "SourceHanSerifCN-Medium", sans-serif;
    }
    .title {
      font-family: "SourceHanSerifCN-Medium", sans-serif;
    }
    .content {
      font-family: "SourceHanSansCN-Light", sans-serif;
    }
    .spec {
      font-size: 36px;
      font-family: "SourceHanSansCN-Light", sans-serif;
    }
    .main-txt {
      font-family: "SourceHanSansCN-Light", sans-serif;
    }
    .more-details {
      font-family: "SourceHanSansCN-Light", sans-serif;
    }
    p {
      font-family: "SourceHanSansCN-Light", sans-serif;
    }
    .more {
      font-family: "SourceHanSansCN-Light", sans-serif;
    }
    &.group-layout-1 {
      box-sizing: border-box;
      padding: 0 430px 0 222px;
      .media-section {
        width: 592px;
        height: 848px;
        margin-right: 50px;
      }
      .text-section {
        margin-top: 34px;
        .sub-title-1 {
          margin-bottom: 10px;
        }
        .sub-title-2 {
          margin: 10px 0 10px;
        }
      }
    }
    &.group-layout-2 {
      margin: 78px auto 150px;
      .media-section {
        width: 930px;
        height: 730px;
      }
      .text-section {
        padding: 65px 165px 0 280px;
        box-sizing: border-box;
        .sub-title-2 {
          margin-top: 10px;
        }
        .main-content {
          margin-top: 40px;
          .main-title {
            margin-bottom: 29px;
          }
        }
      }
    }
    &.group-layout-3 {
      box-sizing: border-box;
      padding: 0 430px 0 280px;
      .media-section {
        width: 640px;
        height: 360px;
        margin-right: 85px;
      }
      .text-section {
        .sub-title-1 {
          margin: 15px 0 35px;
        }
      }
    }
    &.group-layout-4 {
      box-sizing: border-box;
      padding: 0 360px 0 280px;
      margin: 140px auto;
      .media-section {
        width: 640px;
        height: 360px;
        margin-left: 40px;
        flex-shrink: 0;
      }
      .text-section {
        .sub-title-1 {
          margin: 10px 0 30px;
        }
      }
    }
    &.group-layout-5 {
      color: #000000;
      padding: 0 370px 118px 280px;
      box-sizing: border-box;
      .group-layout-container {
        align-items: flex-start;
        .media-section {
          width: 640px;
          height: 360px;
          margin-right: 86px;
        }
        .text-section {
          margin-top: 0;
          .main-title {
            margin-bottom: 35px;
          }
          .sub-title-1 {
            margin-bottom: 10px;
          }
          .content {
            line-height: 27px;
          }
          .mb_50 {
            margin-bottom: 50px;
          }
        }
      }
      .group-layout-list {
        margin: 130px 0 107px;
        .group-layout-item {
          position: relative;
          &:last-child {
            margin-left: 238px;
            &::after {
              width: 0;
              height: 282px;
              border-right: 1px dashed #000000;
              display: inline-block;
              content: "";
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              left: -120px;
            }
          }
          .main-title {
            font-size: 36px;
          }
          .main-subtitle {
            font-size: 26px;
            margin: 19px 0 34px;
          }
          .main-txt {
            font-size: 18px;
            line-height: 27px;
          }
        }
      }

      .text-section {
        margin-top: 107px;
        .main-title {
          margin-bottom: 25px;
        }
      }
    }
    .media-section {
      flex-shrink: 0;
    }
    .text-section {
      color: #000000;
      .main-title {
        font-size: 36px;
      }
      .sub-title-1 {
        font-size: 28px;
      }
      .sub-title-2 {
        font-size: 26px;
      }
      .content {
        font-size: 18px;
        line-height: 26px;
      }
      .spec {
        font-size: 36px;
      }
      .highlight {
        font-size: 22px;
        font-weight: bold;
      }
      .more-details {
        width: 450px;
        height: 50px;
        background: #e9e9e9;
        font-size: 20px;
        color: #000000;
        margin-top: 59px;
      }
    }
  }
  .other_wrap {
    position: relative;
    margin-bottom: 127px;
    background: url("https://upload.vwingist.com/melscn/0image/2025/03/5227416754654129227.png")
      no-repeat center;
    background-size: cover;
    width: 100%;
    height: 750px;
    padding: 120px 0 0 279px;
    box-sizing: border-box;
    .content {
      width: 695px;
      align-items: flex-start;
      color: #000000;
      .title {
        font-size: 36px;
        white-space: nowrap;
      }
      .txt1 {
        font-size: 26px;
        margin: 3px 0 50px;
      }
      .txt2 {
        font-size: 36px;
      }

      .txt {
        margin: 50px 0 40px;
        font-size: 20px;
        p {
          line-height: 27px;
          &:last-child {
            margin-top: 30px;
          }
        }
      }
    }
  }
  .join_wrap {
    position: relative;
    margin-bottom: 127px;
    background: url("https://upload.vwingist.com/melscn/0image/2025/04/5175367247852106837.png")
      no-repeat center;
    background-size: cover;
    width: 100%;
    height: 750px;
    padding: 120px 0 0 279px;
    box-sizing: border-box;
    .content {
      width: 695px;
      align-items: flex-start;
      .title {
        color: #000000;
        .txt1 {
          font-size: 60px;
        }
        .txt2 {
          font-size: 36px;
          margin: 5px 0;
        }
        .txt3 {
          font-size: 50px;
        }
      }
      .txt {
        margin: 50px 0 40px;
        font-size: 20px;
        p {
          line-height: 27px;
          &:last-child {
            margin-top: 10px;
          }
        }
      }
      .more {
        width: 165px;
        height: 50px;
        background: #e9e9e9;
        font-size: 20px;
        cursor: pointer;
        &:hover {
          background: #333333;
          color: #fff;
        }
      }
    }
  }
}
</style>